import {PluginAdvancedAudioDescription, pluginName} from './plugin-advanced-audio-description';
import {registerPlugin} from '@playkit-js/kaltura-player-js';

registerPlugin(pluginName, PluginAdvancedAudioDescription as any);
